"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addLogoutInterceptor = void 0;
const selectors_1 = require("astra-core/containers/AccountProvider/selectors");
const slice_1 = require("astra-core/containers/AccountProvider/slice");
const slice_2 = require("astra-core/containers/BasketProvider/slice");
const storage_1 = require("../../utils/storage");
const constants_1 = require("../../utils/storage/constants");
const virtual_games_1 = require("../../utils/virtual-games");
const addLogoutInterceptor = (axiosInstance, store, virtualGamesRoutes) => {
    axiosInstance.interceptors.response.use((response) => response, (error) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const is403 = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 403;
            const state = store.getState();
            const currentUser = (0, selectors_1.selectAccount)(state);
            if (is403 && currentUser !== undefined) {
                const { pathname } = window.location;
                const userOnVirtualGamesPage = (0, virtual_games_1.isOnVirtualGamePage)(pathname, virtualGamesRoutes);
                const responseFromVirtualGames = (0, virtual_games_1.isResponseFromVirtualGames)(error.config.url);
                if (!responseFromVirtualGames && !userOnVirtualGamesPage) {
                    store.dispatch(slice_2.basketProviderActions.resetState());
                    store.dispatch(slice_1.accountProviderActions.resetUser());
                    store.dispatch(slice_1.accountProviderActions.getUser({}));
                    constants_1.STORAGE_KEYS_TO_REMOVE_AFTER_LOGOUT.map(storage_1.removeLocalStorageItem);
                }
            }
        }
        catch (e) {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            console.error(`Cannot handle logout: ${e}`);
        }
        return yield Promise.reject(error);
    }));
};
exports.addLogoutInterceptor = addLogoutInterceptor;
//# sourceMappingURL=interceptors.js.map